import script from "./NotificationActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationActivity.vue?vue&type=script&setup=true&lang=js"

import "./NotificationActivity.vue?vue&type=style&index=0&id=a694f270&lang=css"

const __exports__ = script;

export default __exports__